import CryptoJS from 'crypto-js';
import type { IError, IFile } from '@shared/index';
import type { IResponse } from '../types';

export class Utils {
    static getBase64(file: File, callback: Function) {
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = function () {
			const result = {
				name: file.name,
				size: file.size,
				type: file.type,
				extension: file.name.split('.').pop(),
				base64: reader.result
			}
			callback(null, result)
		}
		reader.onerror = function (error) {
			callback(error)
		}
	}

	static getBase64Sync(file: File) {
		return new Promise<IFile>((resolve, reject) => {
			Utils.getBase64(file, (err: any, result: IFile) => {
				if (err) return reject(err)
				else resolve(result)
			})
		})
	}

    static encryptValue = (data: any): string => {
		if (!data) return ''
		const key = CryptoJS.enc.Base64.parse('MTIzNDU2Nzg5MDEyMzQ1Ng==')
		const iv = CryptoJS.enc.Base64.parse('MTIzNDU2Nzg5MDEyMzQ1Ng==')
		const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(data)), key, {
			keySize: 128 / 8,
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		})

		data = encrypted.toString()
		return data
	}

	static decryptValue = (data: any) => {
		if (!data) return null
		const key = CryptoJS.enc.Base64.parse('MTIzNDU2Nzg5MDEyMzQ1Ng==')
		const iv = CryptoJS.enc.Base64.parse('MTIzNDU2Nzg5MDEyMzQ1Ng==')

		const decrypted = CryptoJS.AES.decrypt(data, key, {
			keySize: 128 / 8,
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		})

		const decryptedData = decrypted.toString(CryptoJS.enc.Utf8)

		return JSON.parse(decryptedData)
	}

    static createResponse<T>(success: boolean, data: T | IError | null): IResponse<T> {
		return { success, data: success ? (data as T) : null, error: success ? null : (data as IError) } as IResponse<T>
	}

	static getTransformedText(
		content: string,
		replacingSymbol: string,
		replacedToSymbol: string,
	) {
		return content.split(replacingSymbol).join(replacedToSymbol);
	};

	static removedZeroAfterDot(value: string | undefined) {
		if (!value) {
			return '';
		}
		const arr: string[] = value.split('.');
		
		if (parseInt(arr[1]) > 0) {
			return value;
		} else {
			return arr[0];
		}
	};

	static formatDate(date: Date | string, locale: string): string {
		const dateObject = new Date(date);
		const options: Intl.DateTimeFormatOptions = {
			day: 'numeric',
			month: 'short',
			year: 'numeric',
		};
		return dateObject.toLocaleDateString(locale, options);
	};

	static formatDateToDay (
		date: Date | string,
		locale: string,
		) {
		const dateObject = new Date(date);
		const options: Intl.DateTimeFormatOptions = {
			day: 'numeric',
			month: 'short',
		};
		return dateObject.toLocaleDateString(locale, options);
	};

	static daysFrom (
		date: Date | string,
		today: string,
		dayAgo: string,
		daysAgoRuVar: string,
		daysAgoEnVar: string,
		locale: string,
	  ) {
		const currentDateStamp = new Date().getTime() - new Date(date).getTime();
	  
		const days = Math.floor(currentDateStamp / (1000 * 60 * 60 * 24));
	  
		switch (days) {
		  case 0:
			return today;
		  case 1:
			return dayAgo;
		  case 2:
		  case 3:
		  case 4:
			return `${days} ${daysAgoRuVar}`;
		  case 5:
		  case 6:
		  case 7:
			return `${days} ${daysAgoEnVar}`;
		  default:
			return Utils.formatDate(date, locale);
		}
	}
}
  